import { getJupasOrderRankLabel } from './jupasOrderDisplay';

export function jupasRankLabelToIndex(label) {
  const match = String(label || '').trim().match(/^([A-E])(\d+)$/i);
  if (!match) return -1;
  const band = match[1].toUpperCase();
  const num = parseInt(match[2], 10);
  const offsets = { A: 0, B: 3, C: 6, D: 10, E: 15 };
  if (!(band in offsets)) return -1;
  return offsets[band] + num - 1;
}

export function parseElectivesText(text) {
  if (!text?.trim()) return [];
  return text.split(',').map((segment) => segment.trim()).filter(Boolean).map((segment) => {
    const parts = segment.split(/\s+/);
    if (parts.length >= 2) {
      return { subjectCode: parts[0], score: parts.slice(1).join(' ') };
    }
    return { subjectCode: '', score: segment };
  });
}

export function parseJupasRankingText(text) {
  if (!text?.trim()) return [];
  return text.split(/\s*;\s*/).filter(Boolean).map((segment, fallbackIndex) => {
    const trimmed = segment.trim();
    const match = trimmed.match(/^([A-E]\d+)\s+(\S+)(?:\s+(.*))?$/i);
    if (match) {
      const rankLabel = match[1].toUpperCase();
      return {
        rankLabel,
        code: match[2],
        title: match[3]?.trim() || '',
        index: jupasRankLabelToIndex(rankLabel),
      };
    }
    return {
      rankLabel: getJupasOrderRankLabel(fallbackIndex),
      code: trimmed,
      title: '',
      index: fallbackIndex,
    };
  });
}

export function parseSurveyResponseScores(row) {
  const core = [
    { subjectCode: 'CHI', score: row.dseChinese || '' },
    { subjectCode: 'ENG', score: row.dseEnglish || '' },
    { subjectCode: 'MAT', score: row.dseMath || '' },
    { subjectCode: 'CSD', score: row.dseCsd || '' },
  ];
  const electives = parseElectivesText(row.dseElectives);
  return {
    core,
    electives,
    spnBonus: row.spnBonus,
    spnBonusDetails: row.spnBonusDetails,
  };
}

export function getOfferBandColor(bandKey) {
  const colors = {
    A: '#FECCCB',
    B: '#FFDA8F',
    C: '#FEFF99',
    D: '#99FFCD',
    E: '#B3D7F9',
    Other: '#E0E0E0',
  };
  return colors[bandKey] || colors.Other;
}

export function buildPageItems(currentPage, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = new Set([1, totalPages, currentPage, currentPage - 1, currentPage + 1]);
  if (currentPage <= 3) {
    [2, 3, 4].forEach((page) => pages.add(page));
  }
  if (currentPage >= totalPages - 2) {
    [totalPages - 3, totalPages - 2, totalPages - 1].forEach((page) => pages.add(page));
  }

  const sorted = [...pages].filter((page) => page >= 1 && page <= totalPages).sort((a, b) => a - b);
  const items = [];
  sorted.forEach((page, index) => {
    if (index > 0 && page - sorted[index - 1] > 1) {
      items.push(`ellipsis-${sorted[index - 1]}`);
    }
    items.push(page);
  });
  return items;
}
